import Vue from 'vue';
import MessageVue from './index.vue';

// 定义插件对象
const VerifyPassword = {};
// vue的install方法用于定义vue插件
VerifyPassword.install = vue => {
  const LutticaMessageInstance = vue.extend(MessageVue);
  let currentMessage;
  const initInstance = () => {
    // 实例化vue实例
    currentMessage = new LutticaMessageInstance();
    const msgBoxEl = currentMessage.$mount().$el;
    document.body.appendChild(msgBoxEl);
  };
  // 在vue的原型上添加实例方法，以全局调用
  Vue.prototype.$verifyPassword = {
    info(options) {
      if (!currentMessage) {
        initInstance();
      }
      Object.assign(currentMessage, options);
      return currentMessage
        .show()
        .then(val => {
          currentMessage = null;
          return Promise.resolve(val);
        })
        .catch(err => {
          currentMessage = null;
          return Promise.reject(err);
        });
    },
    remove() {
      if (currentMessage && currentMessage.$mount().$el) {
        document.body.removeChild(currentMessage.$mount().$el);
      }
    },
  };
};
export default VerifyPassword;
